import axios from 'axios';
import useAuthStore from '../store/useAuthStore';

// Determine the API base URL based on environment and current location.
const inferBaseUrl = () => {
  // If explicitly set in environment, use it
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  
  // In production (e.g. Vercel), use relative path to let the server/proxy handle it
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  if (typeof window === 'undefined') return '/api';

  const { hostname, protocol } = window.location;
  
  // WORKAROUND: For now, always use direct backend URL
  // This bypasses CRA proxy issues
  // In production, you would check the environment and use appropriate URLs
  const backendHost = hostname === 'localhost' || hostname === '127.0.0.1' 
    ? 'localhost' 
    : hostname;
  const backendPort = process.env.REACT_APP_BACKEND_PORT || '5000';
  return `${protocol}//${backendHost}:${backendPort}/api`;
};

const API_BASE_URL = inferBaseUrl();

console.log('🔗 API_BASE_URL:', API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false
});

apiClient.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const hasAuthHeader = Boolean(config.headers?.Authorization);

    console.log('📤 API Request:', {
      method: config.method.toUpperCase(),
      url: config.url,
      fullUrl: `${API_BASE_URL}${config.url}`,
      hasAuthHeader
    });

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const currentToken = useAuthStore.getState().token;

    // If we *thought* we were authenticated but got a 401, the token is
    // missing/invalid/expired. Clear it so routing redirects to /login.
    // Avoid interfering with expected 401s when no token is present (e.g. bad login).
    if (status === 401 && currentToken) {
      useAuthStore.getState().logout();
    }

    return Promise.reject(error);
  }
);

export { API_BASE_URL };
export default apiClient;
